import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import { PortfolioContentTwo } from "./projectTwo/PortfolioContentTwo";

export const PortfolioCanvas = () => {
  return (
    <div>
      <NavBar />
      <PortfolioContentTwo />
      <Footer />
    </div>
  );
};
